import { fetchCanonicalSnippets, fetchCanonicalTemplates } from "./canonicalMessagingApi";
import { snippetsForQuickReplyPicker } from "./canonicalSnippetAdapter";

// Presentation fields retained by the bulk/campaign editors, not provider resources.
export async function loadSnippetChoices() {
  return snippetsForQuickReplyPicker(await fetchCanonicalSnippets());
}

export async function loadTemplateChoices() {
  return (await fetchCanonicalTemplates()).filter(item => item.status === "approved").map(item => {
    const components = item.components || [];
    const parameters = components.flatMap(component => component.parameters || [])
      .filter((field, index, all) => field.key && all.findIndex(other => other.key === field.key) === index);
    return {
      ...item,
      elementName: item.name,
      body: components.find(component => component.type === "body")?.text || "",
      footer: components.find(component => component.type === "footer")?.text || "",
      customParams: parameters.map(field => ({ paramName: field.key, required: field.required })),
      buttons: components.flatMap(component => component.buttons || []),
    };
  });
}
